// src/assets/components/SectionTitle.jsx
import React from "react";

const SectionTitle = ({ title, subTitle, className }) => {
  return (
    <div className={className}>
      <h2 className="text-t3 text-text-default pb-[8px] whitespace-pre-line">
        {title}
      </h2>
      {subTitle && (
        <p className="text-b2 text-text-subtler whitespace-pre-line">
          {subTitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
